export default {
      id: "no-internet-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#no-internet",
      toString: function () {
        return this.url;
      }
    }